import { connect } from 'react-redux';
import { authenticateProfile } from 'components/login-form/actions';

import EmissionsDemo from './component';

// Selectors
import {
  getLegendValues,
  getSelectedBasemap,
  getSelectedLabels,
  getSelectedLanguage,
  getSelectedPollutant,
} from './selectors';

// Actions
import {
  reset,
  fetchProducts,
  restoreState,
  setBasemap,
  setLabels,
  setViewport,
} from './actions';

const mapStateToProps = state => ({
  loading: state.emissionsDemo.products.loading,
  legendValues: getLegendValues(state),
  basemap: getSelectedBasemap(state),
  labels: getSelectedLabels(state),
  language: getSelectedLanguage(state).value,
  selectedPollutant: getSelectedPollutant(state),
});

const mapDispatchToProps = dispatch => ({
  reset: () => dispatch(reset()),
  authentication: () => dispatch(authenticateProfile()),
  fetchData: () => dispatch(fetchProducts()),
  restoreState: () => dispatch(restoreState()),
  setBasemap: basemap => dispatch(setBasemap(basemap)),
  setLabels: labels => dispatch(setLabels(labels)),
  setViewport: viewport => dispatch(setViewport(viewport)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsDemo);



// WEBPACK FOOTER //
// ./src/components/emissions-demo/index.js